/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
import React, { useState } from 'react'

import i18n from 'live/services/i18n'

import {
    IOverviewAlarmEvent,
    IOverviewAsset
} from 'plugin-codaf-risk-ext-bowtie/BowtieManagment/components/AssetSelector/AssetSelector'
import { IBowtie } from 'plugin-codaf-risk-ext-bowtie/types'

import { IAlarmEvent } from '../../../../../../../types/alarms'
import { AlarmColors } from '../../../../../../../types/enums'
import { AlarmCardContainer, DiagramSelectedView, BowtieSelectedView } from './styles'

interface IProps {
    onCardClick?: () => void
    alarm: IOverviewAlarmEvent
    // setAlarmData: (k: IAlarmEvent) => void
    type: 'overview' | 'dashboard'
    asset: IOverviewAsset
    alarmBowties: IBowtie[]
    setAlarmData: (k: IOverviewAlarmEvent) => void
    alarms?: Map<number, IAlarmEvent>
    setSelectedBowtie: (k: number) => void
}

export interface ITopEventToAlarm {
    bowtie: IBowtie
    id: number
}

export const AlarmCard: React.FC<IProps> = ({
    alarms,
    onCardClick,
    alarm,
    type,
    setSelectedBowtie,
    alarmBowties,
    setAlarmData
}) => {
    const [viewDiagramRequest, setViewDiagramRequest] = useState<boolean>(false)
    const [viewBowtieRequest, setViewBowtieRequest] = useState<boolean>(false)

    const renderBowtieNames = (): JSX.Element[] => {
        return alarmBowties?.map((bt, idx) => {
            return (
                <div
                    key={idx}
                    className="bowtie-diagram-view"
                    onClick={e => {
                        e.stopPropagation()
                        setSelectedBowtie(bt.id)
                    }}
                >{`${bt.bowtieCode} | ${bt.topEvent.name} | ${bt.topEvent.hazard.name} | ${bt.topEvent.hazard.operation.description}`}</div>
            )
        })
    }

    const dateConverter = (date: number): string => {
        const newDate = new Date(date)
        const converted = moment(newDate).format('ddd, MMM DD, YYYY hh:mm:ss a')

        return `${converted}`
    }

    const cardColor = (): string => {
        switch (alarm?.status) {
            case AlarmColors.FATAL:
                return '#AE1F1F'
                break
            case AlarmColors.WARN:
                return '#FF9326'
                break
            case AlarmColors.ERROR:
                return '#FF9326'
                break
            case AlarmColors.INFO:
                return '#00BFFF'
                break
            default:
                return 'gray'
        }
    }

    return (
        <AlarmCardContainer
            onClick={onCardClick}
            color={cardColor()}
            style={{
                width: type === 'dashboard' ? '100%' : 450
            }}
        >
            <div className="alarm-card first-row">
                <div className="first-row-spans">
                    <span className="entity-span">{`${i18n(alarm.entity)} "${alarm.entityName}" `.toLowerCase()}</span>
                    <div className="hadan">
                        <span className="had-a-span">{i18n('had an ')}</span>
                        <span className="colored-span">{i18n(`${alarm.status} event detected`)}</span>
                    </div>
                </div>
                <i
                    className="fas fa-ellipsis-v"
                    onClick={e => {
                        e.stopPropagation()
                        setViewDiagramRequest(!viewDiagramRequest)
                        setViewBowtieRequest(false)
                        setAlarmData(alarm)
                    }}
                />
            </div>
            <div className="alarm-card second-row">
                <i className="fas fa-check"></i>
                <div className="second-row-spans">
                    <span className="triggered-span">{i18n('Acknowledge')}: </span>
                    <span className="time-span">
                        {alarm?.acknowledges && alarm?.acknowledges[0]
                            ? i18n(alarm?.acknowledges[0]?.acknowledge + ' ' + 'alarm')
                            : i18n('No acknowledge')}
                    </span>
                </div>
            </div>
            <div className="alarm-card third-row">
                <i className="far fa-clock" />
                <div className="second-row-spans">
                    <span className="triggered-span">{i18n('Last triggered')}</span>
                    <span className="time-span">{dateConverter(alarm.date)}</span>
                </div>
            </div>
            {viewDiagramRequest && (
                <DiagramSelectedView
                    onClick={e => {
                        e.stopPropagation()
                        setViewBowtieRequest(!viewBowtieRequest)
                    }}
                    color={viewBowtieRequest ? 'var(--gray-200)' : 'var(--gray-0)'}
                >
                    <i className="fal fa-external-link" />
                    {i18n('Diagram view')}
                </DiagramSelectedView>
            )}
            {viewBowtieRequest && <BowtieSelectedView>{renderBowtieNames()}</BowtieSelectedView>}
        </AlarmCardContainer>
    )
}
